import * as api from "./apis/ssoSignup";
import { setTokens } from "./setTokens";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { ssoSignup, ssoAuthTokens };
async function ssoSignup(ssoUserCredentials, userDetails, userProfile, clientId) {
  try {
    sendNewRelicEvent({
      EventName: 'sso_sigup_start',
      provider: ssoUserCredentials.provider.toLowerCase()
    });
    var signUpSsoResponse = await api.ssoSignup(ssoUserCredentials, userDetails, userProfile, clientId);
    var tokens = signUpSsoResponse.tokens,
      encryptedEmail = signUpSsoResponse.encryptedEmail,
      encryptedCheggId = signUpSsoResponse.encryptedCheggId,
      uuid = signUpSsoResponse.uuid;
    var idToken = tokens.idToken,
      accessToken = tokens.accessToken;
    sendNewRelicEvent({
      EventName: 'sso_sigup_success',
      provider: ssoUserCredentials.provider.toLowerCase()
    });
    emit('signup.success', {
      tokens: tokens,
      encryptedEmail: encryptedEmail,
      encryptedCheggId: encryptedCheggId,
      uuid: uuid
    });
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: true
    });
    return signUpSsoResponse;
  } catch (e) {
    triggerError('signup', e);
    sendNewRelicEvent({
      EventName: 'sso_sigup_error',
      provider: ssoUserCredentials.provider.toLowerCase()
    });
    throw e;
  }
}
async function ssoAuthTokens(ssoUserCredentials, clientId) {
  try {
    sendNewRelicEvent({
      EventName: 'sso_auth_tokens_start',
      provider: ssoUserCredentials.provider.toLowerCase()
    });
    var ssoAuthTokensResponse = await api.ssoAuthTokens(ssoUserCredentials, clientId);
    var _ssoAuthTokensRespons = ssoAuthTokensResponse.tokens,
      idToken = _ssoAuthTokensRespons.idToken,
      accessToken = _ssoAuthTokensRespons.accessToken;
    sendNewRelicEvent({
      EventName: 'sso_auth_tokens_success',
      provider: ssoUserCredentials.provider.toLowerCase()
    });
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: true
    });
    return ssoAuthTokensResponse;
  } catch (e) {
    triggerError('signup', e);
    sendNewRelicEvent({
      EventName: 'sso_auth_tokens_error',
      provider: ssoUserCredentials.provider.toLowerCase()
    });
    throw e;
  }
}